// Mock data for Bu Security clone

export const companyInfo = {
  name: "Bu Security",
  tagline: "Trusted Professional Security Guard Services in Florida",
  phone: "888-356-0005",
  email: "info@busecurity.com",
  address: "12750 NW 17 St Suite 207, Miami, FL 33182",
  description: "Reliable Protection for Businesses, Residential Properties, and Events. Secure your peace of mind with expert security solutions tailored to your needs.",
  socialLinks: {
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com",
    yelp: "https://yelp.com"
  }
};

export const services = [
  {
    id: "unarmed-guards",
    title: "Unarmed Guards",
    shortDesc: "Our unarmed security guards are available 24/7 to keep your business safe and your employees secure.",
    fullDesc: "Our professional unarmed security guards provide comprehensive protection for your business without the intimidation of armed personnel. They are fully trained in conflict resolution, emergency response, and customer service to ensure a safe and welcoming environment.",
    image: "https://images.unsplash.com/photo-1485230405346-71acb9518d9c?w=600&h=800&fit=crop",
    features: ["24/7 Availability", "Trained Professionals", "Customer Service Focused", "Emergency Response Ready"]
  },
  {
    id: "armed-guards",
    title: "Armed Guards",
    shortDesc: "Our professionally trained armed security guards are fully equipped to protect your property from theft.",
    fullDesc: "Our armed security guards undergo rigorous training and are licensed to carry firearms. They provide maximum protection for high-risk environments, valuable assets, and situations requiring enhanced security measures.",
    image: "https://images.unsplash.com/photo-1552739883-6578dc150ac6?w=600&h=800&fit=crop",
    features: ["Licensed & Certified", "Extensive Training", "High-Risk Protection", "Asset Security"]
  },
  {
    id: "mobile-patrols",
    title: "Mobile Patrols",
    shortDesc: "We offer a drive-by security patrol service that can make one or multiple stops per night to secure your location.",
    fullDesc: "Our mobile patrol service provides flexible, cost-effective security coverage for multiple locations. Our patrol officers conduct regular checks, respond to alarms, and provide detailed reports of their visits.",
    image: "https://images.unsplash.com/photo-1584796022980-620c4396aaf6?w=600&h=800&fit=crop",
    features: ["Cost-Effective", "Multiple Location Coverage", "Detailed Reporting", "Alarm Response"]
  },
  {
    id: "event-security",
    title: "Event Security",
    shortDesc: "We can provide temporary security for special events such as corporate meetings, conventions and concerts.",
    fullDesc: "From corporate events to large concerts, our event security team ensures your guests' safety while maintaining a welcoming atmosphere. We handle crowd control, access management, and emergency response.",
    image: "https://images.unsplash.com/photo-1571283056653-e9802feac258?w=600&h=800&fit=crop",
    features: ["Crowd Control", "Access Management", "VIP Protection", "Emergency Planning"]
  },
  {
    id: "employee-termination",
    title: "Employee Termination",
    shortDesc: "We provide security guards that can escort high-risk employees off the premises after termination.",
    fullDesc: "Employee terminations can be volatile situations. Our trained security professionals ensure smooth transitions by escorting terminated employees from the premises professionally and safely.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=600&h=800&fit=crop",
    features: ["Discreet Service", "Professional Handling", "Risk Mitigation", "Documentation"]
  },
  {
    id: "surveillance-monitoring",
    title: "Surveillance Monitoring",
    shortDesc: "We can help with the procurement, installation, and monitoring of video surveillance equipment.",
    fullDesc: "Our surveillance monitoring services include state-of-the-art camera systems, 24/7 monitoring, and rapid response to suspicious activities. We help you see everything, everywhere, all the time.",
    image: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=600&h=800&fit=crop",
    features: ["24/7 Monitoring", "HD Camera Systems", "Remote Access", "Incident Recording"]
  }
];

export const industries = [
  {
    id: "apartment-complexes",
    title: "Apartment Complexes",
    description: "Comprehensive security solutions for residential communities, ensuring tenant safety and property protection.",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=600&h=400&fit=crop"
  },
  {
    id: "medical-facilities",
    title: "Medical Facilities",
    description: "Specialized healthcare security protecting patients, staff, and sensitive medical information.",
    image: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&h=400&fit=crop"
  },
  {
    id: "bank-security",
    title: "Bank Security",
    description: "High-level financial institution protection with armed guards and surveillance systems.",
    image: "https://images.unsplash.com/photo-1541354329998-f4d9a9f9297f?w=600&h=400&fit=crop"
  },
  {
    id: "grocery-stores",
    title: "Grocery Stores",
    description: "Retail security solutions preventing theft and ensuring customer and employee safety.",
    image: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=600&h=400&fit=crop"
  },
  {
    id: "hotel-security",
    title: "Hotel Security",
    description: "Hospitality security services protecting guests, staff, and property around the clock.",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=600&h=400&fit=crop"
  },
  {
    id: "construction-sites",
    title: "Construction Sites",
    description: "Site security protecting valuable equipment, materials, and preventing unauthorized access.",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&h=400&fit=crop"
  }
];

export const offices = [
  {
    city: "Miami",
    address: "12750 NW 17 St Suite 207, Miami, FL 33182",
    phone: "888-356-0005",
    email: "miami@busecurity.com",
    isHeadquarters: true
  }
];

export const testimonials = [
  {
    name: "Timothy Moon",
    company: "Zion Market",
    text: "Zion Market has only been serviced by United Guard Services, never having to look for a different service provider. With up to 20,000 customers weekly, their performance is extremely well done, secure, and professional. In addition, they work as if they are part of the Zion family."
  },
  {
    name: "Sarah Johnson",
    company: "Pacific Hotels Group",
    text: "United Guard Services has been protecting our properties for over 5 years. Their professionalism and attention to detail is unmatched in the industry."
  },
  {
    name: "Michael Chen",
    company: "Bay Area Construction",
    text: "Our construction sites have never been more secure. The mobile patrol service gives us peace of mind knowing our equipment is protected 24/7."
  }
];

export const clientLogos = [
  { name: "Zion Market", logo: "https://via.placeholder.com/80x80?text=ZM" },
  { name: "Pacific Hotels", logo: "https://via.placeholder.com/80x80?text=PH" },
  { name: "Bay Construction", logo: "https://via.placeholder.com/80x80?text=BC" },
  { name: "Metro Bank", logo: "https://via.placeholder.com/80x80?text=MB" },
  { name: "Fresh Foods", logo: "https://via.placeholder.com/80x80?text=FF" },
  { name: "City Medical", logo: "https://via.placeholder.com/80x80?text=CM" },
  { name: "Urban Living", logo: "https://via.placeholder.com/80x80?text=UL" },
  { name: "Tech Corp", logo: "https://via.placeholder.com/80x80?text=TC" }
];

export const jobOpenings = [
  {
    id: 1,
    title: "Armed Security Officer",
    location: "Miami, FL",
    type: "Full-time",
    requirements: ["Valid Guard Card", "Firearms Permit", "2+ years experience", "Clean background check"]
  },
  {
    id: 2,
    title: "Unarmed Security Guard",
    location: "Fort Lauderdale, FL",
    type: "Full-time / Part-time",
    requirements: ["Valid Guard Card", "High school diploma", "Customer service skills"]
  },
  {
    id: 3,
    title: "Mobile Patrol Officer",
    location: "Orlando, FL",
    type: "Full-time",
    requirements: ["Valid Driver's License", "Valid Guard Card", "Clean driving record"]
  },
  {
    id: 4,
    title: "Event Security Specialist",
    location: "Multiple Locations",
    type: "Part-time / On-call",
    requirements: ["Valid Guard Card", "Flexible schedule", "Crowd management experience preferred"]
  }
];
